exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.oc-table-plus-btn[data-v-39989c10], .oc-table-minus-btn[data-v-39989c10] {min-width: 30px;}\n", ""]);

